export type ThemeVariation = {
  theme: string | null;
  config: string | null;
};

export const extractThemeVariation = ({
  themeTemplateContent,
}: {
  themeTemplateContent: string | null | undefined;
}): ThemeVariation => {
  if (!themeTemplateContent || themeTemplateContent.trim() === '') {
    return {
      theme: null,
      config: null,
    };
  }

  // Extract config block: {% config %}...{% endconfig %}
  const configPattern = /{%\s*config\s*%}([\s\S]*?){%\s*endconfig\s*%}/i;
  const configMatch = themeTemplateContent.match(configPattern);

  // Extract theme block: {% theme %}...{% endtheme %}
  const themePattern = /{%\s*theme\s*%}([\s\S]*?){%\s*endtheme\s*%}/i;
  const themeMatch = themeTemplateContent.match(themePattern);

  return {
    theme: themeMatch?.[1]?.trim() ?? null,
    config: configMatch?.[1]?.trim() ?? null,
  };
};

export type BuildFinalContentParams = {
  templateContent: string | null | undefined;
  themeTemplateContent: string | null | undefined;
};

export const buildFinalContent = ({
  templateContent,
  themeTemplateContent,
}: BuildFinalContentParams): string => {
  let finalContent = templateContent ?? '';

  if (!themeTemplateContent || themeTemplateContent.trim() === '') {
    return finalContent;
  }

  // Extract theme and config from theme template
  const { theme, config } = extractThemeVariation({
    themeTemplateContent,
  });

  if (theme && config) {
    // Inject config into <head>
    const headRegex = /(<head[^>]*>)/i;
    finalContent = finalContent.replace(
      headRegex,
      head => `${head}\n${config}\n`,
    );

    // Inject theme into <body>
    const bodyRegex = /(<body[^>]*>)/i;
    finalContent = finalContent.replace(
      bodyRegex,
      body => `${body}\n${theme}\n`,
    );
  }

  return finalContent;
};
